
    const data = {"name":"src/core/icons/navigation-variant","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M21 3 3 10.53v.97l6.84 2.66L12.5 21h.96L21 3Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            